
import AppSection from "./AppSection"
import Article from "./Article"
import AppButton from "./AppButton"
import stubDirectives from "../mixins/stubDirectives"
import markRaw from "../helpers/markRaw"

export default {
  components: {
    AppSection,
    Article,
    AppButton
  },
  mixins: [stubDirectives],
  props: {
    heading: {
      type: String,
      default: ""
    },
    subheading: {
      type: String,
      default: ""
    },
    smallHeading: {
      type: String,
      default: ""
    },
    copy: {
      type: Object,
      default: null
    },
    article: {
      type: Array,
      default: () => []
    },
    fontColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: null
    },
    containImage: {
      type: Boolean,
      default: false
    },
    stackImageOnMobile: {
      type: Boolean,
      default: false
    },
    stackImageOnMobileReverse: {
      type: Boolean,
      default: false
    },
    largeTextPadding: {
      type: Boolean,
      default: false
    },
    button: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      AppButton: markRaw(AppButton)
    }
  },
  computed: {
    buttonProps() {
      const buttonBlock = this.button && this.button[0]
      if (buttonBlock) {
        const { _uid, component, ...props } = buttonBlock
        return props
      }
      return null
    }
  }
}
